import { Token } from "./LocalStorage.props";

const setToken = (tokenObj: Token) => {
    localStorage.setItem("access_token", JSON.stringify(tokenObj?.access_token));
    localStorage.setItem("refresh_token", JSON.stringify(tokenObj?.refresh_token));
};

const getAccessToken = () => {
    return JSON.parse(localStorage.getItem("access_token") as string);
};

const getRefreshToken = () => {
    return JSON.parse(localStorage.getItem("refresh_token") as string);
};

const LocalStorage = {
    setToken,
    getAccessToken,
    getRefreshToken
};

export default LocalStorage;